import Nullstack from 'nullstack';
export default function IconOlympicsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-olympics-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 6a3 3 0 1 0 3 3"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "9",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M9 9a3 3 0 0 0 3 3m2.566 -1.445a3 3 0 0 0 -4.135 -4.113"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "15",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M12.878 12.88a3 3 0 0 0 4.239 4.247m.586 -3.431a3.012 3.012 0 0 0 -1.43 -1.414"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}